module.exports = __webpack_public_path__ + "img/Logos-17.4f88a96c.png";